import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold px-3 mt-8 -mb-3" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "w-2/3" }
const _hoisted_6 = { class: "font-bold text-left" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "flex w-full justify-between" }
const _hoisted_10 = { class: "text-white flex items-center gap-2 font-bold" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "h-[35rem] flex items-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-share mr-3" }, null, -1)

import { computed } from "vue"
  import { arrowBackCircle, ellipsisHorizontal, copy } from "ionicons/icons"
  import { modalController } from "@ionic/vue"
  import { toastController } from "@ionic/core"

  import BottomModal from "@/components/template/BottomModal.vue"

  /**
   * close modal
   */
  interface Details {
    video: string
    title: string
    description: string
  }

  interface CompanyObject {
    name: string
    image: string
  }

  interface Props {
    cultureData: Details[]
    companyData: CompanyObject
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CultureStories',
  props: {
    cultureData: null,
    companyData: null
  },
  setup(__props: any) {

const props = __props as {
    cultureData: Details[]
    companyData: CompanyObject
  }

  const close = () => {
    modalController.dismiss()
  }

  

  const storyId = (storyItem: any) =>
    storyItem.title
      .toLowerCase()
      .replace(/[^a-z0-9\s+]/g, "")
      .replace(/\s+/g, "-")
  const shareOptions = ["Share to LinkedIn", "Share to Facebook", "Copy URL"]

  /**
   * get window location
   */
  const getLocation = () => window.location.toString()

  /**
   * Share function
   * share
   */
  const copyUrl = async (storyId: string) => {
    navigator.clipboard.writeText(getLocation().includes(`#${storyId}`) ? getLocation() : `${getLocation()}#${storyId}`)
    const toast = await toastController.create({
      message: "Culture Story link copied to clipboard!",
      duration: 3000,
      position: "top",
      color: "info",
    })
    await toast.present()
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, "Culture Stories at " + _toDisplayString(__props.companyData.name), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cultureData, (culture, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${culture}_id`,
        class: "px-3 my-8"
      }, [
        _createElementVNode("div", {
          id: `${storyId(culture)}`,
          class: "w-full flex gap-3 my-3"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("iframe", {
              width: "100%",
              height: "100%",
              style: {"border-radius":"20px"},
              src: `${culture.video}?autoplay=1`,
              frameborder: "0",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: ""
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(culture.title.length > 30 ? `${culture.title.slice(0, 29)}...` : culture.title), 1),
            _createElementVNode("p", {
              class: "text-left",
              innerHTML: culture.description.length > 30 ? `${culture.description.slice(0, 29)}...` : culture.description
            }, null, 8, _hoisted_7),
            _createElementVNode("button", {
              id: `${index}_stories`,
              class: "underline"
            }, "open video", 8, _hoisted_8)
          ])
        ], 8, _hoisted_2),
        _createVNode(_component_ion_modal, {
          trigger: `${index}_stories`,
          style: `--ion-background-color: #000000`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_content, { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ion_icon, {
                    class: "text-3xl text-white pl-2",
                    icon: _unref(arrowBackCircle),
                    onClick: close
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("img", {
                      class: "h-8 w-8 rounded-base",
                      src: __props.companyData.image,
                      alt: ""
                    }, null, 8, _hoisted_11),
                    _createTextVNode(" " + _toDisplayString(__props.companyData.name), 1)
                  ]),
                  _createElementVNode("button", {
                    id: `${index}_share`
                  }, [
                    _createVNode(_component_ion_icon, {
                      class: "text-3xl text-white pl-2",
                      icon: _unref(ellipsisHorizontal)
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("iframe", {
                    width: "100%",
                    height: "40%",
                    style: {"border-radius":"20px"},
                    src: `${culture.video}?autoplay=1`,
                    frameborder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: ""
                  }, null, 8, _hoisted_14)
                ]),
                _createElementVNode("p", {
                  class: "truncate ... text-white",
                  innerHTML: culture.description.length > 30 ? `${culture.description.slice(0, 29)}...` : culture.description
                }, null, 8, _hoisted_15),
                _createElementVNode("button", {
                  id: `${index}_showMore`,
                  class: "text-white underline"
                }, "show more", 8, _hoisted_16),
                _createVNode(BottomModal, {
                  type: `${index}_showMore`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: culture.description
                    }, null, 8, _hoisted_17)
                  ]),
                  _: 2
                }, 1032, ["type"]),
                _createVNode(BottomModal, {
                  type: `${index}_share`
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shareOptions, (shareOption, index) => {
                      return _createElementVNode("div", {
                        key: `${index}_id`,
                        class: "my-3 text-center"
                      }, [
                        (index === 2)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              expand: "block",
                              color: "white",
                              class: "normal-case",
                              style: { color: 'inherit' },
                              onClick: ($event: any) => (copyUrl(storyId(culture)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  class: "text-xl mr-3",
                                  icon: _unref(copy)
                                }, null, 8, ["icon"]),
                                _createTextVNode(_toDisplayString(shareOption), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_ShareNetwork, {
                              key: 1,
                              network: index == 0 ? 'linkedin' : 'facebook',
                              url: `${getLocation()}${getLocation().includes(`\#${storyId(culture)}`) ? '' : `\#${storyId(culture)}`}`,
                              description: `${culture.description.slice(0, 50)}...}`,
                              title: `${culture.title} Culture Stories - Workbean`,
                              hashtags: "workbean,culture_stories"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  expand: "block",
                                  color: "white",
                                  class: "normal-case",
                                  style: { color: 'inherit' }
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18,
                                    _createTextVNode(_toDisplayString(shareOption), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["network", "url", "description", "title"]))
                      ])
                    }), 64))
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["trigger"])
      ]))
    }), 128))
  ], 64))
}
}

})